import React from 'react';
import { Minus, Plus, Trash2, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';

export const CartItemRow = ({ item, onRemove, onUpdateQuantity }) => (
  <div className="bg-white rounded-lg p-4 border border-stone-taupe/20">
    <div className="flex gap-4">
      <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded-md" />
      <div className="flex-grow">
        <h3 className="font-semibold text-charcoal-ink">{item.name}</h3>
        <p className="text-sm text-stone-taupe capitalize">{item.priceType}</p>
        <p className="text-lg font-bold text-charcoal-ink mt-1">${item.price}</p>
      </div>
      <button
        onClick={() => onRemove(item.id, item.priceType)}
        data-testid={`cart-remove-${item.id}-${item.priceType}`}
        className="text-stone-taupe hover:text-charcoal-ink transition-colors"
      >
        <Trash2 className="w-5 h-5" />
      </button>
    </div>

    <div className="flex items-center gap-3 mt-4">
      <button
        onClick={() => onUpdateQuantity(item.id, item.priceType, Math.max(1, item.quantity - 1))}
        className="w-8 h-8 rounded-md bg-soft-linen hover:bg-stone-taupe/20 flex items-center justify-center transition-colors"
      >
        <Minus className="w-4 h-4 text-charcoal-ink" />
      </button>
      <span className="text-charcoal-ink font-medium w-8 text-center">{item.quantity}</span>
      <button
        onClick={() => onUpdateQuantity(item.id, item.priceType, item.quantity + 1)}
        className="w-8 h-8 rounded-md bg-soft-linen hover:bg-stone-taupe/20 flex items-center justify-center transition-colors"
      >
        <Plus className="w-4 h-4 text-charcoal-ink" />
      </button>
    </div>
  </div>
);

export const UpsellCard = ({ miniFavorInCart, upsellPrice, onUpgrade }) => (
  <div
    data-testid="cart-upsell-party-starter"
    className="bg-gradient-to-br from-soft-linen to-warm-ivory border border-stone-taupe/30 rounded-lg p-4"
  >
    <div className="flex items-start gap-3">
      <div className="w-10 h-10 rounded-full bg-charcoal-ink flex-shrink-0 flex items-center justify-center">
        <Sparkles className="w-5 h-5 text-warm-ivory" />
      </div>
      <div className="flex-grow">
        <p className="text-sm font-semibold text-charcoal-ink">Upgrade to The Party Starter</p>
        <p className="text-xs text-stone-taupe mt-1">
          Get {miniFavorInCart.priceType === 'printed' ? '5 coordinated printed pieces' : '5 coordinated designs'} including a welcome sign &amp; water bottle wraps for just <strong>${upsellPrice}</strong>.
        </p>
        <Button
          onClick={onUpgrade}
          data-testid="cart-upsell-button"
          size="sm"
          className="mt-3 bg-charcoal-ink hover:bg-charcoal-ink/90 text-warm-ivory text-xs"
        >
          Upgrade for ${(upsellPrice - miniFavorInCart.price).toFixed(0)} more →
        </Button>
      </div>
    </div>
  </div>
);
